<!-- src/components/Sidebar.vue -->
<!-- Author Igor Veynik | Site: NexusLab.ru | Telegram: @thenexus | created 30.10.2026 | updated 30.10.2026 -->
<template>
  <aside class="sidebar">
    <router-link to="/" class="brand" @click="$emit('navigate')">
      <svg class="brand-logo" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1442 0.312622C10.9442 0.312622 10.7554 0.404035 10.6325 0.560329L0.269103 13.745C0.0853442 13.9788 0.0870539 14.3068 0.273345 14.5387L10.6398 27.445C10.7628 27.5981 10.9497 27.6874 11.1473 27.6874H22.238C22.437 27.6874 22.625 27.5969 22.7479 27.442L28.5853 20.0866C28.7693 19.8548 28.7701 19.5287 28.5873 19.296L24.5288 14.1299L28.586 8.87082C28.7637 8.64043 28.7634 8.3207 28.5852 8.09064L22.7561 0.563965C22.6334 0.405524 22.4432 0.312622 22.2416 0.312622H11.1442ZM8.2614 7.20338L11.9271 2.53973H21.4515L22.9632 4.49166L20.772 7.20553L8.2614 7.20338ZM6.54596 9.38589L2.8181 14.1286L7.00054 19.3357H17.5654L20.8468 15.1533H8.68673L13.1641 9.38589H6.54596ZM21.8538 9.43263L24.3732 6.31229L26.0544 8.48309L22.6267 12.9262H13.253L15.9651 9.43263H21.8538ZM8.78937 21.5628L11.9199 25.4603H21.4597L26.0431 19.6851L23.0895 15.9254L18.6666 21.5628H8.78937Z" fill="currentColor"/>
      </svg>
      <span class="brand-text">
        <span class="brand-name">СобериЗавод</span>
        <span class="brand-sub">Inside</span>
      </span>
    </router-link>

    <nav class="nav" @click="onNavClick">
      <DynamicMenu
          :show-text="true"
          list-class="nav-list"
          list-item-class="nav-item"
          link-class="nav-link"
          icon-class="nav-icon"
          text-class="nav-text"
          active-class="active"
      />
    </nav>

    <button type="button" class="collapse-btn" :title="collapsed ? 'Развернуть меню' : 'Свернуть меню'" @click="$emit('toggle')">
      <font-awesome-icon icon="angles-left" class="collapse-icon" />
      <span class="nav-text">Свернуть</span>
    </button>
  </aside>
</template>

<script>
import DynamicMenu from '@/components/addons/DynamicMenu.vue'

export default {
  name: 'Sidebar',
  components: { DynamicMenu },
  props: {
    collapsed: { type: Boolean, default: false }
  },
  emits: ['toggle', 'navigate'],
  methods: {
    onNavClick(e) {
      if (e.target.closest('a')) this.$emit('navigate')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--sidebar-bg);
  color: var(--sidebar-text);
  padding: 14px 12px;
  overflow: hidden;
  z-index: 100;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 0 8px;
  margin-bottom: 18px;
  color: #fff;
  white-space: nowrap;
}
.brand:hover { color: #fff; }
.brand-logo { flex: 0 0 auto; }
.brand-text { display: flex; flex-direction: column; line-height: 1.15; }
.brand-name { font-weight: 650; font-size: 15px; letter-spacing: -.01em; }
.brand-sub { font-size: 11px; color: var(--sidebar-text); text-transform: uppercase; letter-spacing: .12em; }

.nav { flex: 1; overflow-y: auto; overflow-x: hidden; margin: 0 -4px; padding: 0 4px; }

:deep(.nav-list) { display: flex; flex-direction: column; gap: 2px; list-style: none; margin: 0; padding: 0; }
:deep(.nav-link) {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 42px;
  padding: 0 12px;
  border-radius: 10px;
  color: var(--sidebar-text);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  transition: background-color .15s var(--ease), color .15s var(--ease);
}
:deep(.nav-link:hover) { background: var(--sidebar-hover); color: #fff; }
:deep(.nav-item.active .nav-link) { background: rgba(37, 99, 235, .18); color: var(--sidebar-active); }
:deep(.nav-item.active .nav-link)::before {
  content: '';
  position: absolute;
  left: -12px; top: 10px; bottom: 10px;
  width: 3px; border-radius: 0 3px 3px 0;
  background: #5b8cff;
}
:deep(.nav-icon) { width: 18px; font-size: 16px; flex: 0 0 18px; }
:deep(.nav-item.active .nav-icon) { color: #7ea6ff; }

.collapse-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 40px;
  padding: 0 12px;
  margin-top: 8px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--sidebar-text);
  cursor: pointer;
  white-space: nowrap;
  font-size: 13px;
}
.collapse-btn:hover { background: var(--sidebar-hover); color: #fff; }
.collapse-icon { width: 18px; flex: 0 0 18px; transition: transform .2s var(--ease); }

.nav-text, :deep(.nav-text), .brand-text { transition: opacity .15s var(--ease); }

/* Мобильный: меню выезжает слева (правила свёрнутого/открытого состояния — в App.vue) */
@media (max-width: 960px) {
  .sidebar {
    position: fixed;
    left: 0; top: 0; bottom: 0;
    width: 260px;
    transform: translateX(-100%);
    transition: transform .22s var(--ease);
    box-shadow: var(--shadow-lg);
  }
  .collapse-btn { display: none; }
}
</style>
